// components/admin/AdminLayout.js - FIXED
import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import AdminSidebar from './AdminSidebar';

const AdminLayout = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // Determine active tab based on current path
    const getActiveTab = () => {
        const path = location.pathname;
        if (path.includes('/admin/categories')) return 'categories';
        if (path.includes('/admin/types')) return 'types';
        if (path.includes('/admin/attendance')) return 'attendance';
        if (path.includes('/admin/admin-attendance')) return 'admin-attendance';
        if (path.includes('/admin/users')) return 'users';
        if (path.includes('/admin/live-tracking')) return 'live-tracking';
        return 'categories'; // fallback
    };

    const [activeTab, setActiveTab] = useState(getActiveTab());

    // Update active tab when location changes
    React.useEffect(() => {
        setActiveTab(getActiveTab());
    }, [location.pathname]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleSidebarNavigation = (tabId) => {
        setActiveTab(tabId);
        const routes = {
            'categories': '/admin/categories',
            'types': '/admin/types',
            'attendance': '/admin/attendance',
            'admin-attendance': '/admin/admin-attendance',
            'users': '/admin/users',
            'live-tracking': '/admin/live-tracking'
        };
        navigate(routes[tabId] || '/admin/categories');
        setIsSidebarOpen(false);
    };

    return (
        <div className="h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100">
            {/* Mobile Header */}
            <div className="lg:hidden bg-white border-b border-gray-200 shadow-sm sticky top-0 z-30">
                <div className="flex items-center justify-between px-4 py-3">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-gradient-to-r from-pink-500 to-purple-500 rounded-xl">
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        </div>
                        <h1 className="text-lg font-bold text-gray-800">Admin Panel</h1>
                    </div>
                    <button
                        onClick={toggleSidebar}
                        className="p-2 hover:bg-gray-100 rounded-lg transition"
                    >
                        <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>
            </div>

            <div className="flex flex-col lg:flex-row h-full">
                {/* Sidebar */}
                <AdminSidebar
                    activeTab={activeTab}
                    setActiveTab={handleSidebarNavigation}
                    isOpen={isSidebarOpen}
                    toggleSidebar={toggleSidebar}
                    user={user}
                />

                {/* Main Content */}
                <main className="flex-1 min-w-0 overflow-auto h-screen">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;